(function () {
    var originalFetch = window.fetch;
    window.fetch = function (input, init) {
        try {
            var urlString = input;
            if (input instanceof Request) {
                urlString = input.url;
            } else if (typeof input !== 'string') {
                // Handle URL objects by converting to string
                urlString = String(input);
            }

            // Ensure we are dealing with a string and it matches the search endpoint
            if (urlString && typeof urlString === 'string' && urlString.indexOf('search/suggest') !== -1) {
                // Check if we are already targeting the English locale
                if (urlString.indexOf('/en/search/suggest') === -1) {

                    var newUrl = urlString;

                    // Case 1: Explicit Hebrew path -> Rewrite to English
                    if (urlString.indexOf('/he/search/suggest') !== -1) {
                        newUrl = urlString.replace('/he/search/suggest', '/en/search/suggest');
                    }
                    // Case 2: Root relative or Absolute without locale -> Insert /en/
                    // Matches "/search/suggest" or "https://.../search/suggest"
                    else if (urlString.indexOf('/search/suggest') !== -1) {
                        newUrl = urlString.replace('/search/suggest', '/en/search/suggest');
                    }
                    // Case 3: Relative path "search/suggest" -> Force root relative /en/search/suggest
                    else if (urlString.indexOf('search/suggest') === 0) {
                        newUrl = '/en/' + urlString;
                    }

                    if (newUrl !== urlString) {
                        console.log('[Predictive Search Fix] Rewriting to:', newUrl);

                        if (input instanceof Request) {
                            // Recreate the Request object with the new URL
                            input = new Request(newUrl, input);
                        } else {
                            // Works for string and URL object (fetch accepts string)
                            input = newUrl;
                        }
                    }
                }
            }
        } catch (err) {
            console.error('[Predictive Search Fix] Error:', err);
        }
        return originalFetch.call(this, input, init);
    };
})();
